<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="View Announcement">
        <v-card-actions>
          <router-link :to="{ name: 'addAnnouncement', params: {} }" title="create Announcement">
            <v-btn absolute right top elevation="1" color="primary">
              <v-icon left>mdi-plus</v-icon>
              create
            </v-btn>
          </router-link>

          <router-link :to="{ name: 'announcementView', params: {} }">
            <v-btn absolute right top elevation="1" color="pink white--text" class="mt-10">
              <v-icon left>mdi-account-tie-voice</v-icon>
              Announcements
            </v-btn>
          </router-link>

        </v-card-actions>
        <v-card flat class="px-2">
          <form @submit.prevent="Save">
            <v-row>
              <v-col cols="12" md="6" lg="3">
                <label class="font-weight-medium body-2">User Type <span class="error--text">*</span></label>
                <v-autocomplete class="my-0 py-1" prepend-icon="mdi-account"
                :items="userOfType"
                key="name"
                item-text="text"
                item-value="name"
                v-model="UserType"
                single-line required
                placeholder="--Select--"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <label class="font-weight-medium body-2">From <span class="error--text">*</span></label>
                <custom-date-picker prepend-icon="mdi-calendar" v-model="fromDate" required />
              </v-col>

              <v-col cols="12" md="6" lg="3">
                <label class="font-weight-medium body-2">To <span class="error--text">*</span></label>
                <div class="control">
                  <custom-date-picker prepend-icon="mdi-calendar" :minToDate="fromDate" v-model="toDate" required />
                </div>
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <label class="font-weight-medium body-2">Filter Action</label>

                <div class="inside">
                  <v-btn class="mr-4" color="success" elevation="1" type="submit">
                    <v-icon left> mdi-text-box-check-outline </v-icon>
                    Apply</v-btn
                  >
                </div>
              </v-col>
            </v-row>
          </form>
        </v-card>
        <v-card-component>
          <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
            <v-card-title>
              Total Records : {{ total }}
              <v-spacer></v-spacer>
            </v-card-title>
            <v-text-field
              :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
              v-model="search"
              append-icon="mdi-magnify"
              class="ml-auto mb-2"
              label="Search"
              hide-details
              single-line
              style="max-width:350px;"
            />
          </v-card-text>
          <v-divider class=" my-0 " />
          <v-data-table
            :footer-props="{
              'items-per-page-options': [5, 10, 20, 40]
            }"
            :items-per-page="10"
            :headers="headers"
            :items="announcments"
            :search="search"
          >
            <template v-slot:item.From="{ item }"> {{ item.user.firstName || '-' }} {{ item.user.lastName || '-' }} </template>
            <template v-slot:item.title="{ item }">
              {{ item.title || '-' }}
            </template>
            <template v-slot:item.Announcement_Type="{ item }">
              <span v-html="item.announcementType.name || '-'"></span>
            </template>

            <template v-slot:item.Date="{ item }">
              {{ new Date(item.createdAt).toLocaleDateString()}}
            </template>

            <template v-slot:item.actions="{ item }">
              <router-link :to="{ name: 'editAnnouncement', params: { announcementID: item.id } }">
                <v-btn class="px-2 ml-1 ma-1" color="success" min-width="0" small>
                  <v-icon small> mdi-pencil</v-icon>
                </v-btn>
              </router-link>
              <router-link :to="{ name: 'viewAnnouncement', params: { announcementID: item.id } }">
                <v-btn class="px-2 ml-1 ma-1" min-width="0" small>
                  <v-icon small color="black"> mdi-eye</v-icon>
                </v-btn>
              </router-link>
              <v-btn class="px-2 ml-1 ma-1" color="error" min-width="0" small v-if="(item.deletedAt = 'null')" @click.prevent="statusChange(item.id)">
                <v-icon small > mdi-trash-can</v-icon>
              </v-btn>
            </template>
            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
            </template>
          </v-data-table>
        </v-card-component>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>

<script>
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import constants from '@/utils/constants'
import moment from 'moment'
import Utils from '@/utils'
import { mapGetters } from 'vuex'
export default {
  name: 'announcementList',
  components: {
    CustomDatePicker,
    MaterialCard,
    VCardComponent
  },
  data () {
    return {
      search: '',
      isLoading: false,
      loadingComponent: null,
      fromDate: moment().format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      maxToDate: moment().format('YYYY-MM-DD'),
      academicYears: [],
      academicYearID: '',
      stages: [],
      inProgress: false,
      franchiseeArr: [],
      franchiseeID: '',
      UserType: '',
      announcments: [],
      total: '',
      userOfType: [],
      headers: [
        { text: 'From', value: 'From', sortable: true },
        { text: 'Title', value: 'title', sortable: true },
        { text: 'Announcement Type', value: 'Announcement_Type', sortable: true },
        { text: 'Date', value: 'Date', sortable: true },
        { text: 'Action', value: 'actions', sortable: true }
      ]
    }
  },
  async created () {
    await this.getYear()
    await this.onFranchiseeChange()
    await this.getFranchiseeList()
    this.userOfType = [
      { text: 'ALL STAFF', name: 'STAFF_STAFF' },
      { text: 'STAFF_TEACHING', name: 'STAFF_TEACHING' },
      { text: 'STAFF_NON_TEACHING', name: 'STAFF_NON_TEACHING' },
      { text: 'PARENT', name: 'PARENT' },
      { text: 'STUDENT', name: 'STUDENT_WISE' },
      { text: 'ALL', name: 'ALL' }
    ]
  },
  watch: {
    franchisee: async function () {
      await this.onFranchiseeChange()
    },
    academicYear: async function () {
      await this.onFranchiseeChange()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  methods: {
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        // this.clearAll()
        this.inProgress = false
      }
    },
    statusChange: async function (announcementId) {
      let ref = this

      this.$buefy.dialog.confirm({
        title: 'Delete Announcement',
        message: 'Do you really want to <b>Delete</b> this record?',
        confirmText: 'Yes',
        cancelText: 'No',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async () => {
          try {
            ref.loadingComponent = ref.$buefy.loading.open()
            await http.delete(`${constants.API_URL}/api/communication/announcements/${announcementId}`)
            ref.loadingComponent.close()
            this.Save()
            return this.okMsg(`Delete Announcement Successfully`)
          } catch (e) {
            const errorMessage = (e && e.response && e.response.data.message) || e.message
            ref.loadingComponent.close()
            return this.errMsg(errorMessage)
          }
        }
      })
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    getYear: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''

        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getFranchiseeList: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/franchisee`)
        let data = response.data
        this.franchiseeArr = data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    dateValidation: function (start, end) {
      if (start > end) {
        this.$buefy.dialog.alert({
          type: 'is-danger',
          message: 'End Date must be Less than Start Date !',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
        if (this.filter.fromDate) {
          this.filter.fromDate = moment(`03/31/${this.year}`).format('YYYY-MM-DD')
        }
      }
    },
    Save: async function () {
      this.announcments = []
      this.total = ''
      try {
        let getParam = {}
        if (this.franchiseeID.length === 0) {
          this.isLoading = false
          return this.$buefy.toast.open({
            message: 'Please select franchisee',
            type: 'is-danger',
            duration: 4000
          })
        } else {
          getParam.franchiseeID = this.franchiseeID
        }
        getParam.academicYearID = this.academicYearID
        getParam.userType = this.UserType
        getParam.fromDate = this.fromDate
        getParam.toDate = this.toDate
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/communication/announcements/`, {
          params: getParam
        })

        if (data.length === 0) {
          this.$buefy.dialog.alert({
            title: 'No Data',
            message: 'No Data Found',
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        } else {
          this.announcments = data
          console.log(this.announcments)
          this.total = this.announcments.length
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Saving Data', errorMessage)
      }
    }
  }
}
</script>
